import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { adminBaseUrl } from "../routes";
import { headerWithAuthToken } from "../headers";
import { createContent, deleteContent, getContent } from "./queries";

const contentApi = createApi({
  reducerPath: "contentApi",
  baseQuery: fetchBaseQuery({
    baseUrl: adminBaseUrl,
    prepareHeaders: headerWithAuthToken,
  }),
  endpoints: (builder) => ({
    // get content
    getContent: builder.query({
      providesTags: ["content"],
      query: getContent,
    }),
    // create/update content
    createContent: builder.mutation({
      invalidatesTags: ["content"],
      query: createContent,
    }),

    // delete content
    deleteContent: builder.mutation({
      invalidatesTags: ["content"],
      query: deleteContent,
    }),
  }),
});

export const {
  useCreateContentMutation,
  useDeleteContentMutation,
  useGetContentQuery,
  reducerPath: contentApiReducerPath,
  reducer: contentApiReducer,
  middleware: contentApiReducerMiddleware,
} = contentApi;
